import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './EssentialOrAdvancedModal.module.scss';

const OtherPlansModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="EssentialOrAdvancedModal" isOpen={isOpen} variant="noFooter">
      <SalonModal.Header>
        <div className={CN.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <IconStatus width="lg" variant="success">
          <Icon selected width="l1" variant="confirm" />
        </IconStatus>

        <div className={CN.modalContent}>
          <div className={CN.modalTitle}>{t('stylistScreen.otherPlansModal.title')}</div>
        </div>
      </SalonModal.Body>
    </SalonModal>
  );
};

export default OtherPlansModal;
